import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/utils/utils.ts';
import { forwardRef, ReactNode } from 'react';

export const DashboardCard = forwardRef<
  HTMLDivElement,
  {
    children?: ReactNode;
    className?: string;
    isLoading?: boolean;
  }
>(({ children, className, isLoading }, ref) => {
  return (
    <div
      ref={ref}
      tabIndex={-1}
      className={cn(
        'flex flex-col gap-3 rounded-lg p-3',
        isLoading ? 'bg-white opacity-80' : 'bg-white',
        className
      )}
    >
      {isLoading && <Skeleton className="h-full w-full bg-white" />}
      {!isLoading && children}
    </div>
  );
});

DashboardCard.displayName = 'DashboardCard';
